import { PublicClientApplication, Configuration } from '@azure/msal-browser';

let msalInstance: PublicClientApplication | null = null;

const initializeMsalInstance = (config: Configuration) => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(config);
  }
};

const getMsalInstance = (): PublicClientApplication => {
  if (!msalInstance) {
    throw new Error(
      'MSAL instance has not been initialized. Call initializeMsalInstance with a configuration.'
    );
  }
  return msalInstance;
};

export { initializeMsalInstance, getMsalInstance };
